export default {
  path: 'tree_test',
  component: () => import(/* webpackChunkName: "user-list" */ '@/pages/tree/treeList'),
  meta: {title:'树形结构'}
}